var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "modal-body" }, [
    _c("div", { staticClass: "control-list", attrs: { id: "controlList" } }, [
      _c(
        "div",
        { staticClass: "control-item bad" },
        [
          _c(
            "strong",
            [
              _c(
                "font",
                {
                  staticStyle: { "vertical-align": "inherit" },
                  attrs: { dir: "auto" },
                },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [_vm._v("Younger doubles")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.clientChecks, function (item) {
            return _c(
              "div",
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "vertical-align": "inherit" },
                        attrs: { dir: "auto" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "control-item bad" },
        [
          _c(
            "strong",
            [
              _c(
                "font",
                {
                  staticStyle: { "vertical-align": "inherit" },
                  attrs: { dir: "auto" },
                },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [_vm._v("Supervisor double")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.attendantChecks, function (item) {
            return _c(
              "div",
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "vertical-align": "inherit" },
                        attrs: { dir: "auto" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "control-item warn" },
        [
          _c(
            "strong",
            [
              _c(
                "font",
                {
                  staticStyle: { "vertical-align": "inherit" },
                  attrs: { dir: "auto" },
                },
                [
                  _c(
                    "font",
                    {
                      staticStyle: { "vertical-align": "inherit" },
                      attrs: { dir: "auto" },
                    },
                    [_vm._v("Qualification")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.missingChecks, function (item) {
            return _c(
              "div",
              [
                _c(
                  "font",
                  {
                    staticStyle: { "vertical-align": "inherit" },
                    attrs: { dir: "auto" },
                  },
                  [
                    _c(
                      "font",
                      {
                        staticStyle: { "vertical-align": "inherit" },
                        attrs: { dir: "auto" },
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item) +
                            "\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }